import React from "react";
import ProductSlides from './ProductSlides';
import ProductDetail from './ProductDetail';
import ProductRelate from './ProductRelate';

class ContentProductDetail extends React.Component {
  constructor(props)
  {
    super(props);
    this.state = {
      productAmount: 1
    }
  }
  handleAddtoWishlist = (productId)=>{
    this.props.handleAddtoWishlist(productId)
  }
  handleUpdateAmount = (amount)=>{
    this.setState({
      productAmount: amount
    })
  }
  handlePreOrder = ()=>{
    let $ = window.jQuery;
    let amount = parseInt($('#qty').val());
    this.props.handlePreOrder(amount);
  }
  addToCart = (product, redirect, cnt=false)=>{
    console.log("Product", product);
    let $ = window.jQuery;
    let {cart} = this.props,
    idx = -1;
    if(cart.length)
    {
        idx = cart.findIndex((item)=>parseInt(item.id) === parseInt(product.product_id));
        if(idx > -1)
        {
          // Limit in case has order limit
          if(product.order_limit > 0)
          {
            let max_amount = Math.min(product.order_limit, product.in_stock);
            cart[idx].cnt += cnt ? cnt:parseInt($('#qty').val());
            if(cart[idx].cnt > max_amount)
            {
              cart[idx].cnt = max_amount;
            }
          }
          else 
          {
            let max_amount = product.in_stock;

            cart[idx].cnt += cnt ? cnt:parseInt($('#qty').val());
            if(cart[idx].cnt > max_amount)
            {
              cart[idx].cnt = max_amount;
            }
          }
        }
    }

    (!cart.length || idx === -1) && cart.push({
        id:product.product_id,
        pcd:product.pcd,
        title:product.title,
        price: product.price_after_discount,
        price_origin:product.meta.price,
        category:product.category,
        image: product.image,
        weight:product.weight,
        order_limit: product.order_limit,
        link:product.link,
        cnt:cnt?cnt:parseInt($('#qty').val())
    });

    this.props.onClickAddToCart(cart, redirect);
  }
  render() {
    let {product, wishlist, relate} = this.props,
    {info,rating} = product;
    info.rating = rating;
    
    if(info.event_name){
        if(!info.out_of_stock){
            info.out_of_stock = info.event_in_stock && (info.event_out_stock - info.event_in_stock >= 0)  
        }
    }
    let buttons = !info.out_of_stock ? (info.product_status != "4" && info.product_status != "6" ? 
    <div className="slide-wrap__button d-flex justify-content-between">
      <button onClick={()=>this.addToCart(info, false)} className="btn btn-add-to-cart w-48">
        <i className="fa fa-shopping-cart" /> 
        Thêm vào giỏ hàng</button> 
      <button onClick={()=>this.addToCart(info, true)} className="btn btn-order w-48">Mua ngay</button> 
    </div>
    :
    <div className="slide-wrap__button d-flex justify-content-center">
      <button onClick={this.handlePreOrder} className="btn btn-add-to-cart w-48">
        <i className="fa fa-shopping-bag mr-2" /> 
        Đặt hàng trước</button> 
    </div>
    )
    :<div className="mt-0">
      <h4 className="text-center text-danger font-weight-bold">HẾT HÀNG</h4>
      <p>(Chúng tôi sẽ cập nhật sản phẩm mới trong thời gian sớm nhất)</p>  
    </div>
    return (
      <div className="product-detail row">
          <div className="col-lg-5 slide-wrap">
            <ProductSlides items={product.images} title={product.info.title} videoUrl={product.info.video_url} />
            {buttons}
          </div>
          <div className="col-lg-7 product-detail-wrap no-gutters">
            <ProductDetail handleUpdateAmount={this.handleUpdateAmount}
            product={product}
            productAmount={this.state.productAmount}
            handleAddtoWishlist={this.handleAddtoWishlist}
            info={info} wishlist={wishlist} />      
          </div>
          <div className="col-12 relate">
            <ProductRelate addToCart={this.addToCart} products={relate} />
          </div>
          
      </div>
    );
  }
}
export default ContentProductDetail;
